import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";

import ActivitySource from "./ActivitySource";
import TimeslotAutoTrackButton from "./TimeslotAutoTrackButton";
import appStyles from "../../../appStyles";
import Icons from "../../common/icons";
import RoundCheckbox from "../../common/RoundCheckbox";
import TimeslotElements from "./TimeslotElements";

export default function TimeslotConfirmedData(props) {
  const {
    timeslot,
    journalContext,
    editMode,
    isAutoReview = false,
    hasAutoTrackedButton = false,
    showTrackTutorials = false,
    isHomeCard = false,
    currentDateTime = null,
    hasChunking,
  } = props;

  const {
    controller,
    bulkSelectedIds,
    isBulkEdit,
    swapCurrentActivity,
    onTimeslotSelected,
    openJournalDialog = () => {},
    openMenuOptions = () => {},
    showIntegrationsMenu = () => {},
    expandTimeslot = () => {},
    toggleTimeslotSelection = () => {},
  } = journalContext || {};

  const minutesInterval = controller.state?.settings?.interval_duration;
  const [isBulkSelected, setIsBulkSelected] = useState(null);
  const [isPartiallySelected, setIsPartiallySelected] = useState(null);
  const [selectedElementIds, setSelectedElementIds] = useState(null);

  let elementIds = [];
  ["", 2, 3].forEach((index) => {
    const element = timeslot[`activity${index}`];
    if (element?.id) elementIds.push(element.id);
  });

  const showUnchunkIcon =
    (hasChunking || timeslot.confirmed) && timeslot.duration > minutesInterval;

  if (bulkSelectedIds) {
    useEffect(() => {
      if (!isBulkEdit) return;

      const elementIdsSet = bulkSelectedIds[timeslot.id] || new Set();
      const allElementsSelected = elementIdsSet.size == elementIds.length;

      setIsPartiallySelected(elementIdsSet.size > 0 && !allElementsSelected);
      setIsBulkSelected(allElementsSelected);
      setSelectedElementIds(elementIdsSet);
    }, [bulkSelectedIds]);
  }

  const onBulkPressed = (element, isSelected) => {
    // Either an element was pressed or the checkbox
    const selectedElementIds = element ? [element.id] : elementIds;

    let newIsSelected = !isSelected;
    // Tapping the checkbox while partially selected => full selects all the pills 
    if (!element &&  isPartiallySelected) newIsSelected = true; 
    
    toggleTimeslotSelection({
      timeslodId: timeslot.id,
      elementIds: selectedElementIds,
      isSelected: newIsSelected,
    });
  };

  const onLongPress = () => {
    if (isBulkEdit) return;
    openMenuOptions(timeslot);
  };

  const onPress = () => {
    if (showTrackTutorials) return;

    // On journal page
    if (onTimeslotSelected) {
      onTimeslotSelected(timeslot);

      // On Edit page
    } else if (swapCurrentActivity) {
      swapCurrentActivity(timeslot.activity);
    }
  };

  const onSourcePressed = (_, isIntegration) => {
    if (isBulkEdit) return;

    if (isIntegration) {
      showIntegrationsMenu(timeslot);
    }
  };

  const { selectedDate } = journalContext || {};
  const showAutoTrack =
    isAutoReview &&
    hasAutoTrackedButton &&
    !isHomeCard &&
    selectedDate == currentDateTime;

  return (
    <>
      {showUnchunkIcon ? (
        <Icons.AddIcon
          style={appStyles.iconContainer}
          onPress={() => expandTimeslot(timeslot)}
        />
      ) : null}

      <View
        style={[
          appStyles.timeslot,
          showAutoTrack
            ? { height: 90, flexDirection: "column", alignItems: "left" }
            : {},
        ]}
      >
        <View style={appStyles.timeslot}>
          {/*   {false && isAutoReview  ? (
            <ImageComponent
              image={require("../../../../assets/track/autotrack_bg.png")}
              style={styles.imageBg}
              onLongPress={onLongPress}
            />
          ) : null} */}

          <TimeslotElements
            timeslot={timeslot}
            onPress={isBulkEdit ? onBulkPressed : onPress}
            onLongPress={onLongPress}
            showUnchunkIcon={showUnchunkIcon}
            isBulkEdit={isBulkEdit}
            selectedElementIds={selectedElementIds}
          />

          {!editMode && timeslot.mood ? (
            <Icons.Journal
              mood={timeslot.mood}
              onPress={() => {
                if (!(showTrackTutorials || isBulkEdit)) {
                  openJournalDialog(timeslot);
                }
              }}
            />
          ) : null}

          <ActivitySource
            source={timeslot.auto_fill_source}
            onPress={onSourcePressed}
            showIconContainer
          />

          {isBulkEdit ? (
            <RoundCheckbox
              size={16}
              hasChildrenChecked={isPartiallySelected}
              checked={isBulkSelected}
              onValueChange={() =>
                onBulkPressed(null, isBulkSelected || isPartiallySelected)
              }
            />
          ) : null}
        </View>

        {showAutoTrack ? (
          <TimeslotAutoTrackButton
            undoId={timeslot.id_chunk}
            journalContext={journalContext}
          />
        ) : null}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  actions: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  imageBg: {
    position: "absolute",
    height: 50,
    left: -12,
    top: -25,
    right: 0,
  },
});
